import { toastAlert } from "../../utils/AlertContext";
import { clippingErrorAlert } from "../../utils/clippingErrorAlert";
import { baseURLFetch } from "../../utils/ConstantsURL";

export const useGenerateClipping = (
  token,
  updateDownloadQueue,
  addToHiperlyncQueue = () => {},
) => {

  const generateClipping = async (
    id_documento,
    fecha,
    nameDocument,
    generateBySection,
    selectedSections,
    onClose,
    config,
    includeHipervinculo = false,
    postClippingURL,
    writeDate = { cover: false, index: false },
    underline,
    excludeWords,
  ) => {
    const tempId = Date.now();
    
    updateDownloadQueue({
      id: tempId,
      nameDocument: nameDocument || "Generando clipping...",
      fecha: new Date().toLocaleDateString("en-GB"),
      generatedAt: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      progress: 0,
      status: "processing",
      message: "Iniciando..."
    });

    onClose();

    try {
      const body = {
        fecha: fecha,
        id_documento: id_documento.toString(),
        nombre_documento: nameDocument,
        config: {
          cover: config.cover,
          index: config.index,
          dividers: config.dividers,
        },
        writeDate: {
          cover: writeDate.cover === true,
          index: writeDate.index === true,
        },
        includeHipervinculo: includeHipervinculo === true,
      };

      if (generateBySection && selectedSections.length > 0) {
        body.id_seccion = selectedSections;
      }

      if (underline && (Array.isArray(underline) ? underline.length > 0 : true)) {
        body.underline = underline;
      }

      if (excludeWords && (Array.isArray(excludeWords) ? excludeWords.length > 0 : true)) {
        body.excludeWords = excludeWords;
      }

      const response = await fetch(postClippingURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al generar el clipping.");
      }


      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let partialData = "";

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        partialData += decoder.decode(value, { stream: true });

        const lines = partialData.split("\n\n");
        partialData = lines.pop();

        for (const line of lines) {
          if (!line.startsWith("data: ")) continue;

          const jsonStr = line.replace("data: ", "").trim();
          if (!jsonStr) continue;

          let data;
          try {
            data = JSON.parse(jsonStr);
          } catch (e) {
            console.error("Error al parsear chunk de progreso:", e);
            continue;
          }

          if (data.type === "progress") {
            updateDownloadQueue({
              id: tempId,
              progress: data.percent,
              message: data.message,
              status: "processing"
            });
          } 
          else if (data.type === "complete") {
            if (!includeHipervinculo && data.document) {
              const { filename, downloadUrl } = data.document;
              
              const fullDownloadUrl = `${baseURLFetch}${downloadUrl}`;

              const generatedAt = new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
              const currentDate = new Date().toLocaleDateString("en-GB");

              updateDownloadQueue({
                id: tempId,
                id_documento,
                nameDocument: filename,
                fecha: currentDate,
                generatedAt,
                url: fullDownloadUrl,
                status: "completed",
                progress: 100
              });
              toastAlert("Clipping generado correctamente", "success");
            } else if (includeHipervinculo && data.hiperlync) {
              const { url, title } = data.hiperlync;
              addToHiperlyncQueue({
                nameDocument: title,
                hiperlync: url,
              });
              updateDownloadQueue({
                id: tempId,
                status: "completed",
                progress: 100,
                message: "Hipervínculo generado"
              });
              toastAlert("Hipervínculos generados correctamente", "success");
            }
          } 
          else if (data.type === "error") {
            throw new Error(data.message);
          }
        }
      }
      
    } catch (error) {
      updateDownloadQueue({
        id: tempId,
        status: "error",
        message: error.message || "Error desconocido"
      });
      toastAlert("Error al generar el clipping: " + error, "error");
      clippingErrorAlert({
        documentName: nameDocument,
        error: error.message,
      });
    }
  };

  return { generateClipping };
};
